import React from 'react';

// eslint-disable-next-line import/no-named-default
import { default as AndroidMarketInfoTable } from '../../Android/MarketInfoTable';
// eslint-disable-next-line import/no-named-default
import { default as IosMarketInfoTable } from '../../iOS/MarketInfoTable';

export const V1_9 = ({ platform }) =>
  platform === 'android' ? <AndroidMarketInfoTable /> : <IosMarketInfoTable />;
